import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IBlackList } from "../interface/IBlackList";
import { IBaseResponse } from "../interface/IBaseResponse";

enum BlackListServiceEnum {
  get = "/",
  createOrUpdate = "/",
}

export default class BlackListService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/black-list");
  }

  public getAll = async (): Promise<IBlackList[]> => await this.GET(BlackListServiceEnum.get);
  public getById = async (id: number): Promise<IBlackList> => await this.GET(BlackListServiceEnum.get + id);
  public createOrUpdate = async (data: IBlackList): Promise<IBaseResponse> => await this.POST(BlackListServiceEnum.createOrUpdate, data);
}
